<template>
    <div>
        <div style="z-index: 1000; position: absolute; left: 100px; top: 16px" v-if="disabledForm && edit">
            <el-button class="search-btn btn-primary" size="small" :disabled="dialogLoading||!permission.globalEdit" @click="disabledFormChange">编辑</el-button>
        </div>
        <div id="SIgoodsEditPage" v-loading="dialogLoading">
            <div class="content-zone">
                <div class="form-main-left">
                    <el-form status-icon :rules="rules" :model="partData" ref="partData" label-width="100px" class="form-ctn">
                        <div class="form-main">
                            <div class="form=line">
                                <div class="form-item" style="width: 100%" v-if="picturesCount > 0 && disabledForm">
                                    <el-form-item label="汽配图片">
                                        <el-image
                                            style="width: 100px; height: 100px; margin-right: 10px"
                                            :key="index"
                                            v-for="(item, index) in reViewList"
                                            :src="item + '?imageView2/2/w/200'"
                                            :z-index="99999"
                                            @click="showGoodsImages(index)"
                                        ></el-image>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="汽配名称" prop="GoodName">
                                        <el-autocomplete
                                            class="search-item"
                                            size="medium"
                                            v-model="partData.GoodName"
                                            :fetch-suggestions="searchGoodName"
                                            :debounce="500"
                                            placeholder="请输入配件名称"
                                            :trigger-on-focus="false"
                                            :disabled="disabledForm"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="英文名称" prop="ExAttribute4">
                                        <el-input v-model="partData.ExAttribute4" class="search-item" size="small" :disabled="disabledForm"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="产地">
                                        <el-autocomplete
                                            size="small"
                                            class="search-item"
                                            v-model="partData.Origin"
                                            :fetch-suggestions="searchOrigin"
                                            :debounce="500"
                                            placeholder="请输入产地"
                                            :trigger-on-focus="false"
                                            :disabled="disabledForm"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="汽配编码" prop="APCode">
                                        <el-input
                                            class="search-item"
                                            size="small"
                                            v-model="partData.APCode"
                                            :disabled="disabledForm"
                                            @change="getAutoSeriesByApCode"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="单位" prop="Unit">
                                        <el-select
                                            size="small"
                                            v-model="partData.Unit"
                                            filterable
                                            allow-create
                                            placeholder=""
                                            @visible-change="unitVisibleChange($event)"
                                            :disabled="disabledForm"
                                        >
                                            <el-option v-for="item in unitList" :key="item.Value" :label="item.Value" :value="item.Value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="预警上限">
                                        <el-input :disabled="disabledForm" type="number" size="small" min="0" v-model="partData.ExAttribute2"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line mb-10">
                                <div class="form-item">
                                    <el-form-item label="汽配分类" prop="ExAttribute1">
                                        <el-select
                                            allow-create
                                            size="small"
                                            v-model="partData.ExAttribute1"
                                            filterable
                                            clearable
                                            reserve-keyword
                                            @visible-change="classifyVisibleChange($event)"
                                            :disabled="disabledForm"
                                        >
                                            <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                                <div class="option-content">
                                                    <div>{{ optionItem.Text }}</div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="汽配品牌" prop="Brand">
                                        <el-select
                                            size="small"
                                            v-model="partData.Brand"
                                            filterable
                                            clearable
                                            allow-create
                                            @visible-change="brandVisibleChange($event)"
                                            :disabled="disabledForm"
                                        >
                                            <el-option v-for="optionItem in brandList" :key="optionItem.Text" :label="optionItem.Text" :value="optionItem.Text">
                                                <div class="option-content">
                                                    <div>{{ optionItem.Text }}</div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="预警下限">
                                        <el-input :disabled="disabledForm" type="number" size="small" v-model="partData.ExAttribute3"></el-input>
                                        <span class="invTip" v-if="!disabledForm" @click="showLimitSet">点击快速设置各仓上下限</span>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item" style="display: flex; flex-wrap: wrap; width: 100%">
                                    <div style="display: flex; align-items: center">
                                        <el-form-item label="成本价" prop="CostPrice">
                                            <div style="display: flex; align-items: center">
                                                <el-input
                                                    type="number"
                                                    step="0.01"
                                                    v-model="partData.CostPrice"
                                                    class="search-item"
                                                    style="width: 150px"
                                                    size="medium"
                                                    @input="onCostPriceInput"
                                                    :min="0"
                                                    :disabled="disabledForm"
                                                >
                                                    <template slot="append">¥</template></el-input
                                                >
                                                <div style="height: 40px; width: 60px; padding-left: 15px">✖&nbsp;</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <div style="display: flex; flex-wrap: wrap; width: 100%">
                                            <el-form-item label-width="50px" label="点数" prop="PricePoint">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        :step="0.1"
                                                        v-model="partData.PricePoint"
                                                        :min="0"
                                                        size="mini"
                                                        style="width: 60px"
                                                        @change="onPricePiontChange"
                                                        oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                        :disabled="disabledForm"
                                                    ></el-input>
                                                    <el-button v-show="isStopAutoCalc && !disabledForm" size="small" class="calc-btn" @click="calcPrice"
                                                        ><i class="fa fa-calculator"></i
                                                    ></el-button>
                                                    <div style="height: 40px; width: auto; padding-left: 6px">&nbsp;=</div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label-width="80px" label="批发价" prop="Price">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="partData.Price"
                                                        class="search-item"
                                                        style="width: 150px"
                                                        size="medium"
                                                        :min="0"
                                                        :disabled="disabledForm"
                                                        @change="onPriceChange"
                                                    >
                                                        <template slot="append">¥</template></el-input
                                                    >
                                                    <el-checkbox
                                                        v-if="!disabledForm"
                                                        style="padding-left: 6px"
                                                        v-model="isRoundNum1"
                                                        :checked="isRoundNum1"
                                                        @change="onIsCeilNumChange1"
                                                        >价格取整</el-checkbox
                                                    >
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div style="display: flex; flex-wrap: wrap; width: 100%">
                                            <el-form-item label-width="50px" label="点数" prop="MarketPricePoint">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        :step="0.1"
                                                        v-model="partData.MarketPricePoint"
                                                        :min="0"
                                                        size="mini"
                                                        style="width: 60px"
                                                        @change="onMarketPPChange"
                                                        oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                        :disabled="disabledForm"
                                                    ></el-input>
                                                    <el-button v-show="isStopAutoCalc && !disabledForm" size="small" class="calc-btn" @click="calcMarketPrice"
                                                        ><i class="fa fa-calculator"></i
                                                    ></el-button>
                                                    <div style="height: 40px; width: auto; padding-left: 6px">&nbsp;=</div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label-width="80px" label="零售价" prop="MarketPrice">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="partData.MarketPrice"
                                                        class="search-item"
                                                        size="medium"
                                                        style="width: 150px"
                                                        :min="0"
                                                        :disabled="disabledForm"
                                                        @change="onMarketPriceChange"
                                                    >
                                                        <template slot="append">¥</template></el-input
                                                    >
                                                    <el-checkbox
                                                        v-if="!disabledForm"
                                                        style="padding-left: 6px"
                                                        v-model="isRoundNum2"
                                                        :checked="isRoundNum2"
                                                        @change="onIsCeilNumChange2"
                                                        >价格取整</el-checkbox
                                                    >
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="库存数">
                                        <el-input :disabled="true" v-model="partData.Inventory" class="search-item" size="small" placeholder="">
                                            <template slot="append">
                                                {{ partData.Unit }}
                                                <el-tooltip effect="dark" placement="bottom">
                                                    <div slot="content">实际在仓数(排除废品仓)：{{ partData.StorageInventory }}</div>
                                                    <span>
                                                        <i class="el-icon-warning-outline" v-if="partData.StorageInventory != partData.Inventory" style="color: red"></i>
                                                    </span>
                                                </el-tooltip>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="待出库" prop="WaitOutCount">
                                        <el-input :disabled="true" v-model="partData.WaitOutCount" class="search-item" size="small" placeholder="">
                                            <el-button v-if="partData.WaitOutCount > 0" slot="append" style="color: orange" @click="showNeedOutData('1')">查看</el-button>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="待入库" prop="WaitInCount">
                                        <el-input :disabled="true" v-model="partData.WaitInCount" class="search-item" size="small" placeholder="">
                                            <el-button v-if="partData.WaitInCount > 0" slot="append" style="color: orange" @click="showNeedInData('1')">查看</el-button>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="留余">
                                        <el-input
                                            :disabled="true"
                                            :value="
                                                partData.StorageInventory -
                                                partData.WaitOutCount +
                                                (isAddWaitOut ? -partData.RWaitOutCount : 0) +
                                                (isAddWaitIn ? partData.WaitInCount + partData.RWaitInCount : 0)
                                            "
                                            class="search-item"
                                            size="small"
                                            placeholder=""
                                        >
                                            <template slot="append">
                                                {{ partData.Unit }}
                                                <el-tooltip effect="dark" placement="bottom">
                                                    <div slot="content">
                                                        留余=实际在仓数-待出数{{ isAddWaitOut ? '-退货待出' : '' }}{{ isAddWaitIn ? '+待入数+退货待入数' : '' }}
                                                    </div>
                                                    <span>
                                                        <i class="el-icon-warning-outline" style="color: orange"></i>
                                                    </span>
                                                </el-tooltip>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="退货待出" prop="RWaitOutCount">
                                        <el-input :disabled="true" v-model="partData.RWaitOutCount" class="search-item" size="small" placeholder="">
                                            <el-button v-if="partData.RWaitOutCount > 0" slot="append" style="color: orange" @click="showNeedOutData('2')"
                                                >查看</el-button
                                            >
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="退货待入" prop="RWaitInCount">
                                        <el-input :disabled="true" v-model="partData.RWaitInCount" class="search-item" size="small" placeholder="">
                                            <el-button v-if="partData.RWaitInCount > 0" slot="append" style="color: orange" @click="showNeedInData('2')">查看</el-button>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="配件尺寸" prop="Size">
                                        <el-input v-model="partData.Size" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="装箱规格" prop="PackingNum">
                                        <el-input
                                            v-model="partData.PackingNum"
                                            class="search-item"
                                            size="small"
                                            placeholder="整箱商品的数量：/箱，/个，/盒…"
                                            :disabled="disabledForm"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="重量">
                                        <el-input v-model="partData.Quality" class="search-item" size="small" placeholder="" :disabled="disabledForm">
                                            <template slot="append">kg</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="材质" prop="Texture">
                                        <el-input v-model="partData.Texture" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="颜色" prop="Color">
                                        <el-input v-model="partData.Color" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                    </el-form-item>
                                </div>
                                <!--占位-->
                                <div class="form-item">
                                    <el-form-item label="在订数" v-if="isIntentShow && goodsId">
                                        <el-input v-model="partData.IntenCount" class="search-item-spe" size="small" placeholder="" disabled>
                                            <el-button
                                                v-if="isIntentShow && goodsId && partData.IntenCount > 0"
                                                slot="append"
                                                style="color: orange"
                                                @click="showIntentDatas()"
                                                >查看</el-button
                                            >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item" style="width: 90%">
                                    <el-form-item label="包装尺寸" class="packageSize">
                                        长
                                        <input v-model.number="partData.Length" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                        &nbsp;宽
                                        <input v-model.number="partData.Width" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                        &nbsp;高
                                        <input v-model.number="partData.Height" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                        (cm)
                                    </el-form-item>
                                </div>
                                <div class="form-item-inten checkbtn">
                                    <el-form-item label="历史存放仓位" v-if="goodsId">
                                        <el-input v-model="partData.IntenSpace" class="search-item" size="small" placeholder="" disabled>
                                            <el-button v-if="goodsId && partData.IntenSpace != '无历史'" slot="append" style="color: orange" @click="showSpacesHistory()"
                                                >查看</el-button
                                            >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line" v-if="!disabledForm">
                                <div class="form-item" style="width: 30%">
                                    <el-form-item label="主要图片">
                                        <uploadFile
                                            ref="uploadMainFile"
                                            type="EntpTempGoods"
                                            :limit="1"
                                            :initfileList="partData.MainImg ? [partData.MainImg] : []"
                                            @uploadSuccess="uploadMainSuccess"
                                            @handleRemove="handleMainRemove"
                                            :wText="watermarkText"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                                <div class="form-item" style="width: 65%">
                                    <el-form-item label="辅助图片">
                                        <uploadFile
                                            ref="uploadMinorFile"
                                            type="EntpTempGoods"
                                            :multiple="true"
                                            :initfileList="uploadPictureList"
                                            @uploadSuccess="uploadMinorSuccess"
                                            @handleRemove="handleMinorRemove"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                            </div>
                            <template v-if="isShowAutoSeriseEng">
                                <div class="form-line">
                                    <div class="form-item" style="width: 300px">
                                        <el-form-item label="英文车型">
                                            <el-input v-model="partData.ExAttribute6" :disabled="disabledForm" class="search-item" size="medium"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" v-if="isShowPerf">
                                        <el-form-item label="绩效属性" prop="PerfSetId" :style="isShowPerf && isShowProject ? 'width:200px' : ''">
                                            <el-select
                                                v-model="partData.PerfSetId"
                                                filterable
                                                clearable
                                                remote
                                                reserve-keyword
                                                size="small"
                                                @visible-change="perfVisibleChange"
                                                :disabled="disabledForm"
                                                :style="isShowPerf && isShowProject ? 'width:130px' : ''"
                                            >
                                                <el-option
                                                    v-for="optionItem in perfSetList"
                                                    :key="optionItem.LevelId"
                                                    :label="optionItem.LevelName"
                                                    :value="optionItem.LevelId"
                                                >
                                                    <span style="float: left">{{ optionItem.LevelName }}</span>
                                                    <span style="float: right; color: #8492a6; font-size: 13px">（{{ optionItem.EarnPoint }}）</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" v-if="isShowProject" :style="isShowPerf && isShowProject ? 'width:200px' : ''">
                                        <el-form-item label="合作项目" prop="ProjectId">
                                            <el-select
                                                class="cate-select search-item"
                                                v-model="partData.ProjectId"
                                                :style="isShowPerf && isShowProject ? 'width:130px' : ''"
                                                filterable
                                                clearable
                                                remote
                                                reserve-keyword
                                                size="small"
                                                :disabled="disabledForm"
                                                @visible-change="projectVisibleChange"
                                            >
                                                <el-option
                                                    v-for="optionItem in projectList"
                                                    :key="optionItem.ProjectId"
                                                    :label="optionItem.ProjectName"
                                                    :value="optionItem.ProjectId"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" :style="isShowPerf && isShowProject ? 'width:300px' : 'width:500px'">
                                        <el-form-item label="自定义属性">
                                            <div v-for="(item, index) in partData.GoodDesc" :key="index">
                                                <el-input
                                                    :class="isShowPerf && isShowProject ? 'gooddesc-input search-item' : 'search-item'"
                                                    size="small"
                                                    v-model="item.key"
                                                    placeholder="请输入名称"
                                                    :disabled="disabledForm"
                                                ></el-input>
                                                <span style="margin: 0 16px">:</span>
                                                <el-input
                                                    :class="isShowPerf && isShowProject ? 'gooddesc-input search-item' : 'search-item'"
                                                    size="small"
                                                    v-model="item.value"
                                                    placeholder="请输入值"
                                                    :disabled="disabledForm"
                                                ></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </div>
                            </template>
                            <div class="form-line" v-else>
                                <div class="form-item" :style="isShowPerf && isShowProject ? 'width:300px' : 'width:500px'">
                                    <el-form-item label="自定义属性">
                                        <div v-for="(item, index) in partData.GoodDesc" :key="index">
                                            <el-input
                                                :class="isShowPerf && isShowProject ? 'gooddesc-input search-item' : 'search-item'"
                                                size="small"
                                                v-model="item.key"
                                                placeholder="请输入名称"
                                                :disabled="disabledForm"
                                            ></el-input>
                                            <span style="margin: 0 16px">:</span>
                                            <el-input
                                                :class="isShowPerf && isShowProject ? 'gooddesc-input search-item' : 'search-item'"
                                                size="small"
                                                v-model="item.value"
                                                placeholder="请输入值"
                                                :disabled="disabledForm"
                                            ></el-input>
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="form-item" v-if="isShowPerf">
                                    <el-form-item label="绩效属性" prop="PerfSetId" :style="isShowPerf && isShowProject ? 'width:200px' : ''">
                                        <el-select
                                            v-model="partData.PerfSetId"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            size="small"
                                            @visible-change="perfVisibleChange"
                                            :disabled="disabledForm"
                                            :style="isShowPerf && isShowProject ? 'width:130px' : ''"
                                        >
                                            <el-option
                                                v-for="optionItem in perfSetList"
                                                :key="optionItem.LevelId"
                                                :label="optionItem.LevelName"
                                                :value="optionItem.LevelId"
                                            >
                                                <span style="float: left">{{ optionItem.LevelName }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">（{{ optionItem.EarnPoint }}）</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item" v-if="isShowProject" :style="isShowPerf && isShowProject ? 'width:200px' : ''">
                                    <el-form-item label="合作项目" prop="ProjectId">
                                        <el-select
                                            class="cate-select search-item"
                                            v-model="partData.ProjectId"
                                            :style="isShowPerf && isShowProject ? 'width:130px' : ''"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            size="small"
                                            :disabled="disabledForm"
                                            @visible-change="projectVisibleChange"
                                        >
                                            <el-option
                                                v-for="optionItem in projectList"
                                                :key="optionItem.ProjectId"
                                                :label="optionItem.ProjectName"
                                                :value="optionItem.ProjectId"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="div-table-row table-title" v-if="partData.WarehouseList && partData.WarehouseList[0]">
                                <div class="div-table-cell border-right" style="width: 40%; background: #f2f6fc">仓库</div>
                                <div class="div-table-cell flex" style="width: 60%">
                                    <div class="border-right cell-item" style="width: 50%; background: #f2f6fc">仓位</div>
                                    <div class="border-right cell-item" style="width: 25%; background: #f2f6fc">数量</div>
                                    <div class="border-right cell-item" style="width: 25%; background: #f2f6fc">标签规格总数</div>
                                </div>
                            </div>
                            <div class="table-main" v-if="(partData.WarehouseList && partData.WarehouseList[0]) || disabledForm">
                                <div v-bind:key="index" class="div-table-row" v-for="(item, index) in partData.WarehouseList">
                                    <div class="div-table-cell border-right" style="width: 40%">
                                        {{ item.WarehouseName }}
                                        <span v-if="item.WarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                                    </div>
                                    <div class="div-table-cell" style="width: 60%">
                                        <div v-bind:key="index" class="cell-line" v-for="(i, index) in item.GoodsLocationList">
                                            <div class="border-right cell-item" style="width: 50%">
                                                {{ i.ShelfSpaceCode }}
                                                <span v-if="i.SpaceType == 2" style="color: #8492a6">(废品仓)</span>
                                                <span v-else-if="i.SpaceType == 1" style="color: #8492a6">(临时仓)</span>
                                            </div>
                                            <div class="border-right cell-item" style="width: 25%">{{ i.Count }}</div>
                                            <div class="border-right cell-item" style="width: 25%">
                                                <span v-if="i.LabelCount == 0 || item.WarehouseType == 1">-</span>
                                                <el-link v-else type="primary" :underline="false" @click="showLabelData(i.SpaceId)">{{ i.LabelCount }}</el-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>

                <div class="form-main-mid">
                    <div class="title">
                        汽配互换码
                        <el-button size="small" class="search-btn btn-primary" v-if="!disabledForm" @click="changeCodeMatchDialog">智能匹配</el-button>
                    </div>
                    <el-input
                        :disabled="disabledForm"
                        class="input-textarea"
                        type="textarea"
                        placeholder="输入请用回车隔行分开，如复制粘贴进来的格式必须带（半角 ',' 或全角逗号 '，'）才会自动转化成标准的回车格式"
                        v-model="enterGoodCode"
                        @paste.native.capture.prevent="handlePaste"
                        @change="getWatermarkText()"
                    ></el-input>
                </div>
                <div class="form-main-right" id="right">
                    <div class="car-type">
                        <div class="label"><span style="color: #f56c6c">*</span>适用车型</div>
                        <el-autocomplete
                            :disabled="disabledForm"
                            class="search-item"
                            size="medium"
                            :debounce="500"
                            v-model="partData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @change="getWatermarkText()"
                        ></el-autocomplete>
                    </div>
                    <div class="row-table" style="margin-bottom: 24px">
                        <div class="row-head">
                            <span>选择的车型</span>
                            <el-button size="small" :disabled="disabledForm" class="search-btn btn-primary" @click="selectCarType">选择车型</el-button>
                            <el-checkbox
                                :disabled="disabledForm"
                                v-model="partData.AllModels"
                                @change="allModelsChange"
                                label="全车型"
                                border=""
                                size="small"
                                style="background-color: #fff; margin-left: 10px"
                            ></el-checkbox>
                        </div>
                        <div class="row-body">
                            <!-- 弹框内选择车型后渲染的数据 -->
                            <div class="row-td" v-for="(item, index) in dialogCheckList" :key="index">
                                <i v-if="!disabledForm" class="el-icon-delete" @click="deleteCarTypeActive(1, index, item)"></i>
                                {{ item.ModelDesc }}
                            </div>
                            <!-- 智能匹配选择车型后渲染的数据 -->
                            <div class="row-td" v-for="(item, index) in brainCheckList" :key="item.AutoSerieId">
                                <i v-if="!disabledForm" class="el-icon-delete" @click="deleteCarTypeActive(2, index, item)"></i>
                                {{ item.ModelDesc }}
                            </div>
                        </div>
                    </div>
                    <div class="row-table">
                        <div class="row-head">
                            <span>智能匹配到的车型</span>
                            <el-select :disabled="disabledForm" v-model="checkedSelect" size="small" @change="changeSelectList">
                                <el-option
                                    v-for="optionItem in checkSelectOptions"
                                    :label="optionItem.Brand"
                                    :key="optionItem.BrandId"
                                    :value="optionItem.BrandId"
                                ></el-option>
                            </el-select>
                            <el-button v-if="!disabledForm" size="small" class="search-btn btn-primary" @click="selectAllHandle">全选</el-button>
                        </div>
                        <div class="row-body">
                            <el-checkbox-group v-model="checkedCurrentList">
                                <el-checkbox
                                    :disabled="disabledForm"
                                    v-for="(item, index) in checkCurrentOptions"
                                    :key="index"
                                    class="checkbox-item"
                                    :label="item"
                                    @change="changeCheckBox($event, item, index)"
                                    :title="item.ModelDesc"
                                    >{{ item.ModelDesc }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer dialog-footer1">
                <div style="text-align: left; width: 50%">
                    <el-button class="search-btn" v-if="!disabledForm" type="primary" @click="showGoodImgRsDialog">共享图片</el-button>
                </div>
                <div style="text-align: right; width: 50%">
                    <el-button class="search-btn btn-primary" v-if="!disabledForm" @click="handleClose('cancle')">放弃编辑</el-button>
                    <el-button class="search-btn btn-primary" v-if="!disabledForm" @click="askconfirm">提交</el-button>
                </div>
            </div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="在订历史"
            :visible.sync="historyVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-inq-dialog"
            style="margin-left: -500px"
        >
            <div v-if="historyVisible">
                <APInquiryHistory ref="APInquiryHistory" :EntpTempGoodsId="goodsId" :Source="1" @closeDialog="closeHistoryDialog"></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="历史存放仓位数据"
            :visible.sync="isShowSpaceHis"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="show-space-dialog"
            style="margin-left: -500px"
        >
            <div v-if="isShowSpaceHis">
                <APSpacesHistory ref="APSpacesHistory" :EntpTempGoodsId="goodsId" @closeDialog="closeHistoryDialog"> </APSpacesHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="needITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="show-space-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="goodsId" :OType="inDataType" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="needOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="show-space-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="goodsId" :OType="outDataType" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="标签数据" :visible.sync="labelDatasVisible" width="800px" append-to-body>
            <div class="dialog-content" v-if="labelDatasVisible">
                <GoodsLabelDatas :GoodsId="goodsId" :SpaceId="spaceId" @closeDialog="labelDatasVisible = false"> </GoodsLabelDatas>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="互换码智能匹配车型" :visible.sync="changeCodeMatchVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="changeCodeMatchVisible">
                <matchAutoSeries :changeCode="enterGoodCode" @closeDialog="confirmSeriesButton"></matchAutoSeries>
            </div>
        </el-dialog>
        <!--    车型选择  :clearOptions="dialogClearOptions"  -->
        <el-dialog title="选择车系" :close-on-click-modal="false" :visible.sync="dialogVisible" :close-on-press-escape="false" append-to-body width="1380px">
            <selectSeries ref="selectSearise" :visible="dialogVisible" :selectOptions="dialogCheckList" :showSets="true" @confirmButton="confirmSeriesButton" />
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="各仓上下限设置" :visible.sync="limitSetVisible" append-to-body width="700px">
            <div class="dialog-content" v-if="limitSetVisible">
                <goodsLimitSet :GoodsId="EntpTempGoodsId" @closeDialog="limitSetClose"></goodsLimitSet>
            </div>
        </el-dialog>
        <!--    关联商品图片    -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="关联图片"
            :visible.sync="goodImgRsVisible"
            width="1000px"
            append-to-body
            :before-close="closeGoodImgRsDialog"
        >
            <div v-if="goodImgRsVisible">
                <goodsImgRs :PictureList="uploadPictureList" :GoodsId="EntpTempGoodsId" @closeDialog="closeGoodImgRsDialog" @setImgRs="upImg"></goodsImgRs>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgReviewList" :z-index="99999" />
    </div>
</template>
<script>
import uploadFile from '@/components/common/uploadBtn.vue';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APSpacesHistory from '@/components/business/goods/APSpacesHistory';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import GoodsLabelDatas from '@/components/business/goods/goodsLabelDatas';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import matchAutoSeries from '@/components/business/goods/matchAutoSeries';
import selectSeries from '@/components/business/goods/selectSeries';
import goodsLimitSet from '@/components/business/goods/goodsLimitSet';
import goodsImgRs from '@/components/business/goods/goodsImgRs';

export default {
    name: '',
    props: {
        EntpTempGoodsId: String,
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        edit: {
            type: Boolean,
            default: true
        }
    },
    components: {
        uploadFile,
        APInquiryHistory,
        APSpacesHistory,
        APNeedInDatas,
        APNeedOutDatas,
        GoodsLabelDatas,
        ElImageViewer,
        matchAutoSeries,
        selectSeries,
        goodsLimitSet,
        goodsImgRs
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let checkAPCode = (rule, value, callback) => {
            let val = value.replace(/^\s+|\s+$/g, ''); //去除前后空格
            if (!val) {
                callback();
            } else {
                this.checkAPCode()
                    .then(() => {
                        return callback(new Error('已存在相同的商品'));
                    })
                    .catch(() => {
                        callback();
                    });
            }
        };
        return {
            limitSetVisible: false,
            isCheckCode: true,
            spaceId: '',
            needITitle: '',
            needOTitle: '',
            needInDataVisible: false,
            needOutDataVisible: false,
            inDataType: '1',
            outDataType: '1',
            title: '配件信息',
            goodsId: this.EntpTempGoodsId,
            disabledForm: true,
            partData: {},
            oldApcode: '', //旧的配件编码，用来判断是否请求存在相同编码的接口
            dialogLoading: false,
            historyVisible: false,
            isIntentShow: false,
            isShowSpaceHis: false,
            labelDatasVisible: false,
            loading: false,
            brandList: [],
            apCategoryList: [],
            unitList: [],
            uploadPictureList: [],
            reViewList: [],
            downloadUrl: this.$util.QN_URL_BASE,
            picturesCount: 0,
            warehouseCount: 0,
            isAddWaitIn: true,
            isAddWaitOut: true,
            isRoundNum1: false,
            isRoundNum2: false,
            rules: {
                APCode: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkAPCode, trigger: 'blur' }
                ],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute1: [{ required: true, message: '该项必填', trigger: 'blur' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                EnName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                HistoryMinPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                HistoryMaxPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Price: [
                    { validator: checkPositive, trigger: 'blur' },
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                MarketPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                CostPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                Quality: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Brand: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Unit: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Inventory: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PerfSetId: [{ required: true, message: '该项必填', trigger: 'blur' }],
                ProjectId: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            sptpsy: false, //商品图片添加水印
            watermarkText: '', //水印内容
            isShowPerf: false, //是否展示绩效属性
            perfSetList: [], //绩效属性列表
            showViewer: false,
            imgReviewList: [],
            projectList: [],
            isCalcPoint: false,
            enterGoodCode: '',
            dialogCheckList: [],
            // 智能车型已选项
            brainCheckList: [],
            // 智能车型-当前下拉框选中项 string BrandId
            checkedSelect: '',
            // 智能车型-下拉框列表 Array
            checkSelectOptions: [],
            // 智能车型-当前展示的列表 Array
            checkCurrentOptions: [],
            // 智能车型-将接口返回的数据缓存这里 Array
            checkAllOptions: [],
            // 智能车型-当前展示列表的已选项 Array
            checkedCurrentList: [],
            // 智能车型-所有列表的已选项-以BrandId为键名 Object
            checkedAllList: {},
            // 车型弹框显隐
            dialogVisible: false,
            // 被删除的车型
            // dialogClearOptions: [],
            //互换码智能匹配弹窗
            changeCodeMatchVisible: false,
            limitSets: [],
            isShowAutoSeriseEng: false,
            isShowProject: false,
            goodImgRsVisible: false, //共享图片弹窗
            isStopAutoCalc: false, //是否停止自动计算点数，停止后反向计算点数也失效
            permission: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getConfigByCodes();
        this.getEnterprisePart();
        this.projectVisibleChange();
        this.permission = this.$util.getPermission('AutoPartsManage');
    },
    mounted() {},
    methods: {
        getConfigByCodes() {
            let codes = ['lybsdr', 'sptpsy', 'syztsj', 'lybsdc', 'qyzdyspsx', 'xzqpbmdwyx', 'fxjsspds', 'splsjpfjmrqz', 'hzxmxzset','zscxyw', 'lspfbgjdsbh'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'lybsdr': //获取留余的计算方式,是否加上采购待入、销售退货待入
                                this.isAddWaitIn = !result;
                                break;
                            case 'sptpsy':
                                this.sptpsy = result;
                                break;
                            case 'syztsj': //获取在订展示配置
                                this.isIntentShow = result;
                                break;
                            case 'lybsdc': //获取留余的计算方式,是否加上采购退货待出仓
                                this.isAddWaitOut = !result;
                                break;
                            case 'qyzdyspsx':
                                this.isShowPerf = result;
                                break;
                            case 'xzqpbmdwyx': //是否检测编码重复
                                this.isCheckCode = result;
                                break;
                            case 'fxjsspds': //反向计算点数
                                this.isCalcPoint = result;
                                break;
                            case 'splsjpfjmrqz': //商品价格取整是否默认开启
                                this.isRoundNum1 = result;
                                this.isRoundNum2 = result;
                                break;
                            case 'hzxmxzset':
                                this.isShowProject = result;
                                break;
                            case 'zscxyw':
                                this.isShowAutoSeriseEng = result;
                                break;
                            case 'lspfbgjdsbh':
                                this.isStopAutoCalc = result;
                                break;
                        }
                    }
                }
            });
        },
        showSpacesHistory() {
            this.isShowSpaceHis = true;
        },
        showGoodsImages(index) {
            let tempImgList = [...this.reViewList]; //所有图片地址
            if (index == 0) {
                this.imgReviewList = tempImgList;
            } else {
                // 调整图片顺序，把当前图片放在第一位
                let start = tempImgList.splice(index);
                let remain = tempImgList.splice(0, index);
                this.imgReviewList = start.concat(remain);
            }
            this.showViewer = true;
        },
        closeViewer() {
            this.showViewer = false;
        },
        checkAPCode() {
            let that = this;
            let val = that.partData.APCode.replace(/^\s+|\s+$/g, ''); //去除前后空格
            if (val == that.oldApcode) {
                return new Promise((resolve, reject) => {
                    reject();
                });
            }
            return new Promise((resolve, reject) => {
                if (that.isCheckCode) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/ValidateEnterprisePartCode',
                            data: {
                                EntpTempGoodsId: that.goodsId,
                                APCode: that.partData.APCode
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.data) {
                                resolve();
                                // 重复了
                            } else {
                                reject();
                            }
                        })
                        .catch(error => {
                            reject();
                        });
                } else {
                    reject();
                }
            });
        },
        //关闭商品编辑dialog
        handleClose(val) {
            let that = this;
            if (that.disabledForm == false) {
                that.$confirm('编辑的信息将不会保存, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        val == 'cancle'
                            ? that.getEnterprisePart().then(() => {
                                  that.disabledForm = true;
                              })
                            : that.$emit('closeDialog');
                    })
                    .catch(() => {
                        that.disabledForm = false;
                    });
            } else {
                that.$emit('closeDialog');
            }
        },
        //取消disable表单
        disabledFormChange() {
            this.disabledForm = false;
            this.getWatermarkText();
        },
        // 上传主图片成功后执行
        uploadMainSuccess(res) {
            this.partData.MainImg = res;
        },
        // 删除主图片
        handleMainRemove(file) {
            this.partData.MainImg = '';
        },
        // 上传辅助图片成功后执行
        uploadMinorSuccess(res) {
            this.uploadPictureList.push(res);
        },
        // 删除辅助图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.uploadPictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length <= 1) that.getConfigData();
            }
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.getEnterprisePartBrandList();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.getEntpApCategoryList();
            }
        },
        //提交表单
        askconfirm() {
            let that = this;
            this.$refs.partData.validate(valid => {
                if (valid) {
                    if (!that.partData.Length) {
                        that.partData.Length = 0;
                    }
                    if (!that.partData.Width) {
                        that.partData.Width = 0;
                    }
                    if (!that.partData.Height) {
                        that.partData.Height = 0;
                    }
                    that.partData.PackageSize = that.partData.Length + '*' + that.partData.Width + '*' + that.partData.Height;

                    if (this.uploadPictureList && this.uploadPictureList.length > 0) {
                        this.uploadPictureList = Array.from(new Set(this.uploadPictureList));
                    }

                    // 提交时插入数据
                    that.partData.GoodsSeriesRs = [];
                    if (that.dialogCheckList.length > 0 || that.brainCheckList.length > 0) {
                        that.partData.GoodsSeriesRs = [...that.dialogCheckList, ...that.brainCheckList];
                    }
                    that.partData.GoodCode = '';
                    if (that.enterGoodCode) {
                        let code = that.enterGoodCode;
                        if (code.indexOf('\n') !== -1) {
                            code = code.split('\n').join(',');
                        }
                        that.partData.GoodCode = code;
                    }

                    let data = this.partData;
                    let saveData = {
                        entpTempGoodsId: this.goodsId,
                        goodCode: data.GoodCode,
                        goodName: data.GoodName,
                        goodDesc: data.GoodDesc,
                        mainImg: data.MainImg,
                        price: data.Price,
                        marketPrice: data.MarketPrice,
                        costPrice: data.CostPrice,
                        PricePoint: data.PricePoint,
                        MarketPricePoint: data.MarketPricePoint,
                        apCode: data.APCode,
                        size: data.Size,
                        quality: data.Quality,
                        brand: data.Brand,
                        origin: data.Origin,
                        color: data.Color,
                        texture: data.Texture,
                        unit: data.Unit,
                        inventory: data.Inventory,
                        exAttribute1: data.ExAttribute1,
                        exAttribute2: data.ExAttribute2,
                        exAttribute3: data.ExAttribute3,
                        exAttribute4: data.ExAttribute4,
                        exAttribute6: data.ExAttribute6,
                        autoSerise: data.AutoSerise,
                        packageSize: data.PackageSize,
                        packingNum: data.PackingNum,
                        pictureList: this.uploadPictureList,
                        PerfSetId: data.PerfSetId,
                        ProjectId: data.ProjectId,
                        AllModels: data.AllModels,
                        GoodsSeriesRs: data.GoodsSeriesRs,
                        Source: '1', //表示商品是从弹窗新增或修改
                        LimitSets: that.limitSets
                    };
                    if (saveData.goodDesc) {
                        let list = saveData.goodDesc;
                        let fIndex = list.findIndex(i => (i.key && !i.value) || (!i.key && i.value));
                        if (fIndex > -1) {
                            that.$message.error('请将自定义属性填写完整');
                            return;
                        } else {
                            let pendList = list.filter(i => i.key && i.value);
                            if (pendList.length > 0) {
                                saveData.goodDesc = pendList.reduce((p, i) => {
                                    return `${p ? p + '|' : ''}${i.key}:${i.value}`;
                                }, '');
                            } else {
                                saveData.goodDesc = '';
                            }
                        }
                    }
                    this.saveEnterprisePart(saveData);
                } else {
                    this.$message({
                        message: '校验不通过',
                        type: 'error'
                    });
                }
            });
        },
        //修改汽配信息
        saveEnterprisePart(formData) {
            let that = this;
            that.dialogLoading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/SaveEnterprisePart',
                    data: formData,
                    hideLoading: true
                })
                .then(response => {
                    if (response.errcode == 0) {
                        that.$util.successMsg('修改成功');
                        that.disabledForm = true;
                        that.dialogCheckList = [];
                        that.getEnterprisePart();
                    }
                })
                .catch(error => {
                    that.dialogLoading = false;
                });
        },
        //获取品牌分类
        getEnterprisePartBrandList() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        //获取汽配分类
        // getEntpApCategoryList() {
        //     this.$util
        //         .getEntpApCategoryList()
        //         .then(data => {
        //             if (!data) return;
        //             this.apCategoryList = data;
        //         })
        //         .catch(() => { });
        // },
        //获取汽配分类
        getEntpApCategoryList() {
            this.$util
                .searchGoodsType()
                .then(data => {
                    if (!data) return;
                    this.apCategoryList = data;
                })
                .catch(() => {});
        },
        //获取单位
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        //获取配件信息
        getEnterprisePart() {
            let that = this;
            that.dialogLoading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetPartInVenData',
                        data: {
                            EntpTempGoodsId: that.goodsId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data.WarehouseList) {
                            that.warehouseCount = data.WarehouseList.length;
                        }

                        that.reViewList = [];
                        if (data.MainImg) {
                            that.reViewList.push(that.downloadUrl + data.MainImg);
                            that.picturesCount = 1;
                        }
                        if (data.PictureList) {
                            that.picturesCount += data.PictureList.length;
                            that.uploadPictureList = [...data.PictureList];
                            for (let i = 0; i < data.PictureList.length; i++) {
                                that.reViewList.push(that.downloadUrl + data.PictureList[i]);
                            }
                        }
                        if (data.PackageSize) {
                            let packageSize = data.PackageSize.split('*');
                            if (packageSize) {
                                data.Length = packageSize[0];
                                data.Width = packageSize[1];
                                data.Height = packageSize[2];
                            }
                        }
                        let packageSize = data.PackageSize.split('*');
                        if (packageSize) {
                            data.Length = packageSize[0];
                            data.Width = packageSize[1];
                            data.Height = packageSize[2];
                        }
                        if (data.GoodDesc) {
                            let goodDescArr = data.GoodDesc.split('|').map(m => {
                                let i = m.split(':');
                                return {
                                    key: i[0],
                                    value: i[1]
                                };
                            });
                            data.GoodDesc = goodDescArr;
                        } else {
                            data.GoodDesc = [{ key: '', value: '' }];
                        }

                        if (data.PerfSetId && (!that.perfSetList || that.perfSetList.length == 0)) {
                            that.$util.getPerfSets().then(list => {
                                if (list) that.perfSetList = list;
                            });
                        }
                        if (data.GoodCode) that.enterGoodCode = data.GoodCode;
                        that.getPartOtherDatas(that.goodsId);
                        that.partData = data;
                        that.oldApcode = data.APCode;
                        resolve();
                    })
                    .finally(() => {
                        that.dialogLoading = false;
                    });
            });
        },
        showIntentDatas() {
            this.historyVisible = true;
        },
        closeHistoryDialog() {
            this.isShowSpaceHis = false;
            this.historyVisible = false;
        },
        updateTableData(id) {
            this.goodsId = id;
            this.getEnterprisePart();
        },
        searchGoodName(key, cb) {
            this.$util.searchPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        searchOrigin(key, cb) {
            this.$util.searchPartAttr(key, 3, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                if (cb) {
                    cb(arr);
                }
            });
        },
        showNeedInData(oType) {
            if (!this.needInDataVisible) {
                this.needITitle = '【配件待入数据】配件编码：' + this.partData.APCode + ' —— 配件名称：' + this.partData.GoodName;
                this.needInDataVisible = true;
                this.inDataType = oType;
            } else if (this.needInDataVisible) {
                this.inDataType = oType;
                this.$refs.APNeedInDatas.updateTableData(this.goodsId, oType);
            }
        },
        showNeedOutData(oType) {
            if (!this.needOutDataVisible) {
                this.needOTitle = '【配件待出数据】配件编码：' + this.partData.APCode + ' —— 配件名称：' + this.partData.GoodName;
                this.needOutDataVisible = true;
                this.outDataType = oType;
            } else if (this.needOutDataVisible) {
                this.outDataType = oType;
                this.$refs.APNeedOutDatas.updateTableData(this.goodsId, oType);
            }
        },
        //成本价数值改变
        onCostPriceInput(val) {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
        //批发价加点改变
        onPricePiontChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            }
        },
        onPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.PricePoint = (this.partData.Price / this.partData.CostPrice).toFixed(2);
        },
        onMarketPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.MarketPricePoint = (this.partData.MarketPrice / this.partData.CostPrice).toFixed(2);
        },
        //市场价加点改变
        onMarketPPChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
         //价格取整
         onIsCeilNumChange1(val) {
            this.isRoundNum1 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            } else {
                if (this.isRoundNum1) {
                    this.partData.Price = Math.ceil(this.partData.Price);
                } else {
                    this.partData.Price = this.partData.Price.toFixed(2);
                }
            }
        },
        onIsCeilNumChange2(val) {
            this.isRoundNum2 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
            else{
                if (this.isRoundNum2) {
                    this.partData.MarketPrice = Math.ceil(this.partData.MarketPrice);
                } else {
                    this.partData.MarketPrice = (this.partData.MarketPrice).toFixed(2);
                }
            }
        },
        showLabelData(spaceId) {
            this.spaceId = spaceId;
            this.labelDatasVisible = true;
        },
        showGoodImgRsDialog() {
            this.goodImgRsVisible = true;
        },
        closeGoodImgRsDialog() {
            this.goodImgRsVisible = false;
        },
        upImg(imgArr) {
            if (imgArr.length > 0) {
                if (this.partData.MainImg == '') {
                    this.partData.MainImg = imgArr[0];
                    imgArr.splice(0, 1);
                }
                let arr1 = [];
                imgArr.forEach(x => {
                    if (this.uploadPictureList.indexOf(x) == -1) {
                        arr1.push(x);
                    }
                });
                let arr2 = this.uploadPictureList.concat(arr1);
                this.uploadPictureList = arr2;
            }
        },
        getWatermarkText() {
            var watermarkText = '';
            let that = this;
            if (that.sptpsy) {
                if (that.partData.APCode != '') {
                    watermarkText = '编码：' + that.partData.APCode;
                }
                if (that.partData.GoodCode != '') {
                    let gcode = that.partData.GoodCode;
                    if (gcode.indexOf('\n') !== -1) {
                        gcode = gcode.split('\n')[0];
                    }
                    watermarkText += ';' + 'O  E：' + gcode;
                }

                if (that.partData.AutoSerise != '') {
                    let autos = that.partData.AutoSerise;
                    if (autos.Length > 50) autos = autos.substring(0, 50);
                    watermarkText += ';' + '车型：' + autos;
                }
            }
            that.watermarkText = watermarkText;
            setTimeout(() => {
                if (that.$refs.uploadMainFile) that.$refs.uploadMainFile.getWatermarkText(watermarkText);
                if (that.$refs.uploadMinorFile) that.$refs.uploadMinorFile.getWatermarkText(watermarkText);
            }, 500);
        },
        perfVisibleChange() {
            let that = this;
            if (that.perfSetList.length == 0) {
                that.$util.getPerfSets().then(data => {
                    if (data) that.perfSetList = data;
                });
            }
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        handlePaste(e) {
            let clip = e.clipboardData.getData('Text');
            if (clip) {
                let newVal = clip.replace(/\s*/g, '').replace(/,/g, '\n').replace(/，/g, ',');
                this.enterGoodCode = this.enterGoodCode + newVal.split(',').join('\n');
            }
        },
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },

        // 把选中数据，去重后插入选择的车型列表中
        //与匹配互换码共用
        confirmSeriesButton(row) {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }

            let newChecks = [];
            if (this.dialogCheckList.length > 0) {
                for (let i = 0; i < this.dialogCheckList.length; i++) {
                    const element = this.dialogCheckList[i];
                    let index = row.findIndex(f => {
                        if (this.changeCodeMatchVisible) return f.AutoSerieId === element.AutoSerieId;
                        else return f[4].split('{$}')[0] === element.AutoSerieId;
                    });

                    if (index > -1) newChecks.push(element);
                }
                this.dialogCheckList = newChecks;
            }

            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    //item = ele[4];
                    item = {
                        AutoSerieId: ele[4].split('{$}')[0],
                        ModelDesc: ele[4].split('{$}')[1]
                    };
                }
                let index = this.dialogCheckList.findIndex(i => {
                    return i.AutoSerieId === item.AutoSerieId;
                });
                if (!~index) {
                    index = this.brainCheckList.findIndex(i => {
                        return i.AutoSerieId === item.AutoSerieId;
                    });
                    if (!~index) {
                        this.dialogCheckList.push(item);
                    }
                }
            });
            // this.dialogClearOptions = [];
            this.dialogVisible = false;
            this.changeCodeMatchVisible = false;
        },
        //全车型选择的变化
        allModelsChange(val) {
            if (val) {
                this.dialogCheckList = [{ BrandId: '全车型', AutoSerieId: '全车型', ModelDesc: '全车型' }];
                //去除智能匹配的选中
                this.brainCheckList = [];
                this.checkedCurrentList = [];
                this.checkSelectOptions.forEach(e => {
                    this.checkedAllList[e.BrandId] = [];
                    e.isAllCheck = false;
                });
            } else {
                this.dialogCheckList = [];
            }
        },
        changeCodeMatchDialog() {
            if (!this.enterGoodCode) {
                this.$message.warning('请输入互换码');
                return;
            }
            this.changeCodeMatchVisible = true;
        },
        // 切换智能车型品牌
        changeSelectList(aId) {
            let list = this.checkAllOptions;
            // 切换选框可选的列表
            this.checkCurrentOptions = list.filter(item => {
                return item.BrandId === aId;
            });
            // 切换当前选框选中集合
            this.checkedCurrentList = this.checkedAllList[aId];
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (this.checkedCurrentList.length === this.checkCurrentOptions.length) {
                if (!this.checkSelectOptions[findIndex].isAllCheck) {
                    this.checkSelectOptions[findIndex].isAllCheck = true;
                }
            }
        },
        // 变更当前列表选中框
        changeCheckBox(result, row, rIndex) {
            this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
            let isAll = this.checkCurrentOptions.length === this.checkedCurrentList.length;
            // 将全选状态置为非全选
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (!result && this.checkSelectOptions[findIndex].isAllCheck) {
                this.checkSelectOptions[findIndex].isAllCheck = false;
            }
            if (isAll) {
                this.checkSelectOptions[findIndex].isAllCheck = true;
            }
            this.noopsycheDataHandle();
        },
        /**
         * 智能匹配车型全选/取消全选
         */
        selectAllHandle() {
            // 没有列表不处理
            if (!this.checkedSelect) return;
            // 获取当前按钮对应列表下标
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            let currentObj = this.checkSelectOptions[findIndex];
            // 筛选出当前列表未选中和选中的数据
            let resultObj = this.filterSingleList();
            if (resultObj.isAll) {
                // 取消全选列表
                this.checkedCurrentList = [];
                this.checkedAllList[this.checkedSelect] = [];
                this.checkSelectOptions[findIndex].isAllCheck = false;
                this.noopsycheDataHandle();
            } else {
                // 全选列表
                this.checkedCurrentList = [...resultObj.checkList, ...resultObj.notCheckList];
                this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
                this.checkSelectOptions[findIndex].isAllCheck = true;
                this.noopsycheDataHandle();
            }
        },
        // 筛选出当前智能车型列表的选中项、未选中项及判断是否全选
        filterSingleList() {
            // 根据两个列表长度判断当前列表是否已经全选
            let partList = this.checkCurrentOptions;
            let isAll = partList.length === this.checkedCurrentList.length;
            if (isAll) {
                return {
                    checkList: this.checkedCurrentList,
                    notCheckList: [],
                    isAll
                };
            } else {
                if (this.checkedCurrentList.length === 0) {
                    return {
                        checkList: [],
                        notCheckList: partList.map(m => m),
                        isAll
                    };
                }
                let checkList = [];
                let notCheckList = [];
                partList.forEach(item => {
                    let index = this.checkedCurrentList.findIndex(c => c.AutoSerieId === item.AutoSerieId);
                    if (~index) {
                        checkList.push(item);
                    } else {
                        notCheckList.push(item);
                    }
                });
                return {
                    checkList,
                    notCheckList,
                    isAll
                };
            }
        },
        // 处理智能车型展示列表
        noopsycheDataHandle() {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }
            let values = Object.values(this.checkedAllList);
            if (values) {
                var arr = values.reduce((p, r) => [...p, ...r], []);
                var newArr = [];
                arr.forEach(e => {
                    let index = this.dialogCheckList.findIndex(i => {
                        return i.AutoSerieId === e.AutoSerieId;
                    });
                    if (!~index) newArr.push(e);
                });
                this.brainCheckList = newArr;
            }
        },
        // 获取智能匹配车型
        async getAutoSeriesByApCode(type, row) {
            this.getWatermarkText();
            const {
                errcode,
                data: { Brands, Series }
            } = await this.$util.axiosPost({
                url: `/api/EntpGoods/GetAutoSeriesByApCode`,
                data: {
                    code: this.partData.APCode
                },
                hideLoading: true
            });
            if (errcode !== 0) {
                this.dialogCheckList = row;
                return;
            }
            if (Brands && Brands.length > 0) {
                // 处理下拉框展示数据
                this.checkSelectOptions = Brands.map(m => {
                    this.checkedAllList[m.BrandId] = [];
                    return {
                        isAllCheck: false,
                        ...m
                    };
                });
                // 当前下拉列表匹配关键字
                this.checkedSelect = this.checkSelectOptions[0].BrandId;
                // 处理智能匹配列表展示的数据
                this.checkCurrentOptions = Series.filter(item => {
                    return item.BrandId === this.checkedSelect;
                });
                this.checkAllOptions = Series;
            } else {
                this.checkedSelect = '';
                this.checkedAllList = {};
                this.checkSelectOptions = [];
                this.checkCurrentOptions = [];
                this.checkAllOptions = [];
            }
            // 处理编辑时展示的数据
            if (type === 'edit') {
                row.forEach(rEle => {
                    let sIndex = Series.findIndex(f => f.AutoSerieId === rEle.AutoSerieId);
                    if (~sIndex) {
                        rEle.BrandId === this.checkedSelect && this.checkedCurrentList.push(Series[sIndex]);
                        this.checkedAllList[rEle.BrandId].push(Series[sIndex]);
                    } else {
                        this.dialogCheckList.push(rEle);
                    }
                });
                if (this.checkSelectOptions.length > 0) this.checkSelectOptions[0].isAllCheck = this.checkedCurrentList.length === this.checkCurrentOptions.length;
                this.noopsycheDataHandle();
            }
        },
        // 删除添加的车型
        deleteCarTypeActive(type, index, row) {
            if (row.ModelDesc == '全车型') this.partData.AllModels = false;
            if (type === 1) {
                // this.dialogClearOptions.push(row);
                this.dialogCheckList.splice(index, 1);
            }
            if (type === 2) {
                if (this.checkedAllList && this.checkedAllList[row.BrandId]) {
                    let checkIndex = this.checkedAllList[row.BrandId].findIndex(i => i.AutoSerieId === row.AutoSerieId);
                    this.checkedAllList[row.BrandId].splice(checkIndex, 1);
                }

                this.noopsycheDataHandle();
                let ctIndex = this.checkSelectOptions.findIndex(f => f.BrandId === row.BrandId);
                if (ctIndex > -1) {
                    if (this.checkSelectOptions[ctIndex].isAllCheck) {
                        this.checkSelectOptions[ctIndex].isAllCheck = false;
                    }
                }

                let singleIndex = this.checkedCurrentList.findIndex(f => f.AutoSerieId === row.AutoSerieId);
                if (singleIndex > -1) this.checkedCurrentList.splice(singleIndex, 1);
            }
        },
        getPartOtherDatas(partId) {
            if (partId) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetPartOtherDatas',
                        data: {
                            EntpTempGoodsId: partId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            let data = res.data;
                            this.uploadPictureList = data.PictureList;

                            this.partData.GoodsSeriesRs = data.GoodsSeriesRs;
                            this.partData.AllModels = data.AllModels;

                            this.getAutoSeriesByApCode('edit', data.GoodsSeriesRs).then(() => {
                                this.partData.AllModels = data.AllModels;
                                if (data.AllModels) this.dialogCheckList = data.GoodsSeriesRs;
                            });
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        showLimitSet() {
            this.limitSetVisible = true;
        },
        limitSetClose(data) {
            this.limitSetVisible = false;
            if (data) {
                this.limitSets = data;
            }
        },
        calcMarketPrice() {
            if (this.isRoundNum2) {
                let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                this.partData.MarketPrice = Math.ceil(p.toFixed(2));
            } else {
                this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
            }
        },
        calcPrice() {
            if (this.isRoundNum1) {
                let p = this.partData.CostPrice * this.partData.PricePoint;
                this.partData.Price = Math.ceil(p.toFixed(2));
            } else {
                this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.invTip {
    font-size: 12px;
    display: inline-block;
    position: absolute;
    top: 28px;
    left: 0;
    color: red;
}

.content-zone {
    display: flex;
    flex-direction: row;
    width: 100%;
}
.dialog-footer1 {
    display: flex;
    margin-top: 20px;
    padding-bottom: 10px;
}
.form-main-mid {
    padding: 0 12px;
    margin: 0 12px;
    border-left: 1px solid #dedede;
    border-right: 1px solid #dedede;
    display: flex;
    flex-direction: column;

    .title {
        padding: 16px 0;
    }

    .input-textarea {
        flex: 1;
    }
}

.form-main-right {
    width: 330px;

    .row-body {
        height: 200px;
        overflow-y: scroll;
        overflow-x: hidden;

        .no-data {
            height: 200px;
            line-height: 200px;
        }
    }

    .car-type {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 16px 0 12px 0;

        .label {
            flex-shrink: 0;
            margin-right: 16px;

            span {
                color: #f56c6c;
            }
        }
    }

    .row-head {
        padding: 12px 16px;
        background-color: #f5f7fa;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        font-weight: 600;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
            flex-shrink: 0;
            margin-right: 16px;
        }
    }

    .row-td {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #ebeef5;
    }

    .checkbox-item {
        width: 100%;
        padding: 12px 16px;
        border-bottom: 1px solid #ebeef5;
    }

    .el-icon-delete {
        font-size: 16px;
        color: #d9220a;
        margin-right: 16px;
        cursor: pointer;
    }
}

.form-main {
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .el-form-item {
        margin-bottom: 10px;
    }
}

.form-line {
    display: flex;
    flex-direction: row;
}

.form-item {
    width: 250px;

    .el-input {
        width: 170px;
    }

    .el-select {
        width: 170px;
    }
}

.form-item-inten {
    width: 350px;

    .el-input {
        width: 150px;
    }
}

.checkbtn {
    text-align: right;
    margin-right: 20px;
}

.table-ctn {
    height: calc(100% - 162px);
    overflow-y: auto;
}

.table-title {
    .cell-item {
        width: 33.33%;
    }

    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}

.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .cell-line {
        display: flex;
        width: 100%;
    }

    .cell-item {
        padding: 0 10px;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
.calc-btn {
    margin-left: 5px;
}
</style>
<style lang="less">
.el-popover {
    max-width: 500px;
}

//辅助图片出现滚条
.el-upload-list {
    max-height: 120px;
    overflow-y: auto;
}

.packageSize {
    input {
        outline: none;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
        width: 100px;
    }

    input:disabled {
        color: #c0c4cc;
        cursor: not-allowed;
        background-color: #f5f7fa;
    }
}

#change-inq-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        width: 1200px;
        box-shadow: 0 0 9px 3px #999;
    }

    .add-row-dialog {
        width: 340px;
        height: auto;

        .form-div {
            margin-top: 20px;
        }

        .dialog-footer {
            text-align: right;
        }
    }

    .el-dialog__body {
        overflow: auto;
    }
}

#show-space-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        width: 600px;
        box-shadow: 0 0 9px 3px #999;
    }

    .add-row-dialog {
        width: 340px;
        height: auto;

        .form-div {
            margin-top: 20px;
        }

        .dialog-footer {
            text-align: right;
        }
    }

    .el-dialog__body {
        overflow: auto;
    }
}

.form-main-left {
    .el-input-group {
        vertical-align: middle;
    }

    .search-item {
        width: 170px;
    }

    .search-item-spe {
        width: 120px;
    }
}

.form-main-mid {
    .el-textarea__inner {
        height: 540px;
    }
}
.gooddesc-input {
    width: 80px !important;
}
</style>
